import { useEffect, useState } from 'react';

function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={scrolled ? 'site-header scrolled' : 'site-header'}>
      <div className="wrap nav">
        <nav className="nav-links" aria-label="주요 메뉴">
          <a href="#why">왜 이동은인가</a>
          <a href="#promise">약속</a>
          <a href="#service">서비스</a>
          <a href="#review">고객후기</a>
          <a href="#recruit">함께하기</a>
          <a href="#contact" className="nav-cta">상담 신청</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
